import TimeLayer from "./TimeLayer";
import NysmMapSet from "../Dataset/NysmMapSet";

import moment from "moment-timezone";

class NysmMapSetLayer extends TimeLayer {
  static types = {
    observations: 0,
    gradient: 1
  };
  constructor(opt_options) {
    const options = opt_options || {};
    const baseOptions = Object.assign({}, options);
    delete baseOptions.dataset;
    delete baseOptions.mapset;
    delete baseOptions.mapid;
    delete baseOptions.mapProjection;
    delete baseOptions.subLayerOptions;
    delete baseOptions.type;
    super(baseOptions);

    this._mapid = options.mapid;
    this._mapset = new NysmMapSet(options.dataset, options.mapset);
    this._mapProjection = options.mapProjection;
    this._subLayerOptions = options.subLayerOptions;
    this._timeManager = options.timeManager;
    this._type = options.type;

    this.load = this.load.bind(this);
    this._map_times_received = this._map_times_received.bind(this);
    this._realtime_data_received = this._realtime_data_received.bind(this);

    this._subscribedToTracking = false;

    this._times_pending = [];
  }

  load(timeManager) {
    const endTime = timeManager.end_date;
    const startTimeDelta = timeManager.start_date
      .clone()
      .subtract(this._mapset.realtime_lag);
    this._mapset
      .get_metadata_in_time_range(startTimeDelta, endTime)
      .then(result => {
        const new_times = {};
        Object.keys(result).forEach(k => {
          new_times[moment.unix(k).valueOf()] = result[k];
        });
        this._map_times_received(new_times, timeManager);
      });
  }

  _map_times_received(new_times, timeManager) {
    const startTime = timeManager.start_date;
    const endTime = timeManager.end_date;
    const startTimeDelta = timeManager.start_date
      .clone()
      .subtract(this._mapset.realtime_lag);
    // Filter to include only the range we care about.
    let addedOneEarly = false;
    let times = [];
    try {
      times = Object.keys(new_times)
        .sort()
        .reverse()
        .map(t => moment(t, "x"))
        .filter(t => {
          if (
            (t >= startTime && t <= endTime) ||
            (t < startTime && t >= startTimeDelta && !addedOneEarly)
          ) {
            if (t < startTime) {
              addedOneEarly = true;
            }
            return true;
          }
          return false;
        });
    } catch (err) {
      console.error(err);
      times = [];
    }
    // Filter times down to those that don't already have layers (or have layers pending), then
    // create layers for any new times.
    const times_loaded = this.getLayers()
      .getArray()
      .map(l => l.get("time").valueOf());
    times
      .filter(
        t =>
          times_loaded.indexOf(t.valueOf()) === -1 &&
          this._times_pending.indexOf(t.valueOf()) === -1
      )
      .forEach(t => {
        let wait = null;
        this._times_pending.push(t.valueOf());
        if (this._type === NysmMapSetLayer.types.gradient) {
          wait = this._mapset.make_gradient_layer(
            this._mapid,
            this._mapProjection,
            t,
            this._subLayerOptions
          );
        } else if (this._type === NysmMapSetLayer.types.observations) {
          wait = this._mapset.make_obs_layer(
            this._mapid,
            this._mapProjection,
            t,
            this._subLayerOptions
          );
        }
        wait.then(new_layer => {
          if (new_layer !== null) {
            this.getLayers().push(new_layer);
          }
          const idx = this._times_pending.indexOf(t.valueOf());
          this._times_pending.splice(idx, 1);
        });
      });
  }

  track_realtime(isTracking, timeManager) {
    if (!isTracking && this._subscribedToTracking) {
      this._mapset.remove_realtime_tracker(this._realtime_data_received);
    } else if (isTracking && !this._subscribedToTracking) {
      this._mapset.add_realtime_tracker(this._realtime_data_received);
    }
    this._subscribedToTracking = isTracking;
  }

  _realtime_data_received(newTime, newData) {
    this._map_times_received(
      { [newTime.valueOf()]: newData },
      this._timeManager
    );
  }
}

export default NysmMapSetLayer;
